import React from 'react'
import axios from 'axios'
import ButtonDialog from '../shared/ButtonDialog'
import { DialogActions, DialogContentText } from '@mui/material'
import { DeleteProps } from '../shared/DeleteProps'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import ScenarioIcon from '@mui/icons-material/Tune'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../context/useAuth'

export default function DeleteScenario({ disabled, value, setData }: DeleteProps) {
  const { name } = useParams()
  const { csrf } = useAuth()
  const [open, setOpen] = React.useState(false)

  return (
    <ButtonDialog
      disabled={disabled}
      title='Delete Scenario'
      icon={<ScenarioIcon />}
      iconButton={<DeleteIcon />}
      content={<DialogContentText>{`Are you sure you want to delete Scenario: ${value.name}?`}</DialogContentText>}
      actions={
        <DialogActions>
          <Button
            color='error'
            variant='contained'
            size='small'
            onClick={async () => {
              try {
                const res = await axios.delete(`${process.env.REACT_APP_API}/${name}/scenario/${value.name}`, {
                  withCredentials: true,
                  headers: {
                    'X-CSRFToken': csrf,
                  },
                })
                setData(res.data)
                setOpen(false)
              } catch (err) {
                console.log('err:', err)
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      }
      open={open}
      setOpen={setOpen}
    />
  )
}
